import type { CommonStoreType } from '@/store/commonStore/types';

type WalletsLoadingState = Pick<
  CommonStoreType,
  'isAuthenticated' | 'pendingWallets' | 'reasonForUpdatingUser' | 'wallets'
>;

export const selectIsAwaitingWallets = ({
  isAuthenticated,
  pendingWallets,
  reasonForUpdatingUser,
  wallets,
}: WalletsLoadingState) =>
  pendingWallets ||
  (isAuthenticated && !wallets.length && !reasonForUpdatingUser);
